'use strict';

angular.module('mean.accounting').controller('CustomerController',
    ['$scope', '$http', 'Global', 'MeanUser', 'commonConstant', 'ngDialog', 'Customers', 'accountingConstant', 'userService', 'toaster', 'Charts',
        function ($scope, $http, Global, MeanUser, commonConstant, ngDialog, Customers, accountingConstant, userService, toaster, Charts) {
            $scope.global = Global;
            $scope.user = MeanUser.user;
            $scope.commonConstant = commonConstant;
            $scope.preferredAccountType = accountingConstant.preferredAccount;
            $scope.vendorTermsType = accountingConstant.vendorTerms;
            $scope.statusType = accountingConstant.status;
            $scope.minDateMoment = moment();
            $scope.addCustomerObj = null;
            $scope.addCustSelectedTab = 'purchasingAgents';
            $scope.customerList = [];
            $scope.sortReverse = false;
            var importCustomersAPI = '/api/accounting/importCustomers';
            $scope.init = function () {
                userService.getMainAccountId($scope.user.username).then(function (id) {
                    $scope.clientAccountId = id;
                    $scope.getAllCustomers();
                })
            };

            $scope.getAllCustomers = function () {
                var customerQuery = { type: 'ARBalance', userId: $scope.clientAccountId }
                if ($scope.status) {
                    customerQuery.status = true;
                }
                Customers.query(customerQuery, function (customer) {
                    customer.map(function(item){
                        if (!item.AR){
                            item.AR = {
                                Balance: item.openingBalance
                            }
                        }
                    })
                    $scope.customerList = customer;
                });
            }
            /**
             * @description Add the new vendor
             */
            $scope.AddCustomerView = () => {
                $scope.addCustomerObj = {
                    address: {
                        street: '',
                        city: '',
                        state: '',
                        zipCode: '',
                        country: ''
                    },
                    isNew: true,
                    contacts: {
                        purchasingAgents: [{ name: '', position: '', email: '', phone: '' }],
                        projectManagers: [{ name: '', position: '', email: '', phone: '' }],
                        other: [{ name: '', position: '', email: '', phone: '' }]
                    }, status: 'Active'
                }
                ngDialog.openConfirm({
                    template: 'accounting/views/customers/addCustomer.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg'
                }).then(function (value) {
                    var customers = new Customers({
                        clientAccountId: $scope.clientAccountId,
                        userId: $scope.user._id,
                        name: value.name,
                        aRContactName: value.aRContactName,
                        phone: value.phone,
                        email: value.email,
                        address: value.address,
                        prefferedPymtMtd: value.prefferedPymtMtd,
                        terms: value.terms,
                        otherTerms: $scope.addCustSelectedTab,
                        openingBalance: value.openingBalance,
                        asOf: value.asOf ? value.asOf.toDate() : new Date(),
                        status: value.status,
                        contacts: value.contacts,
                        addressType: $scope.addCustSelectedTab
                    });
                    customers.$save(function(customer) {
                        $scope.getAllCustomers();
                        toaster.pop('success', 'Added', 'Customer Added Successfully.');
                    });
                });
            };

            /**
             * @description delete the chart account
             * @param {Number} indexValue
             */
            $scope.deleteCustomer = (customer) => {
                $scope.PopupHeading = 'Customer Delete';
                ngDialog.openConfirm({
                    template: 'accounting/views/tmpl/confirmationPopup.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm'
                }).then(function () {
                    customer.isDeleted = true;
                    customer.$update(function(){
                        $scope.getAllCustomers();
                        toaster.pop('success', 'Deleted', 'Customer Deleted Successfully.');
                    }, function(err){
                        toaster.pop('error', 'Error', err.data.error);
                        $scope.getAllCustomers();
                    });
                }, $scope.getAllCustomers);
            };

            /**
             * @description Edit the chart account
             * @param {object} customer
             */
            $scope.editCustomer = (customer) => {
                var customerObj = customer;
                customerObj.asOf = customerObj.asOf ? moment(customerObj.asOf) : moment();
                customerObj.isNew = false;
                $scope.addCustSelectedTab = customerObj.addressType;
                $scope.addCustomerObj = customerObj;
                ngDialog.openConfirm({
                    template: 'accounting/views/customers/addCustomer.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg'
                }).then(function (value) {
                    value.$update(function() {
                        $scope.getAllCustomers();
                        toaster.pop('success', 'Updated', 'Customer Updated Successfully.');
                    });

                }, $scope.getAllCustomers);
            };

            /**
             * @description add the secondary address of the customer under the selected tabs
             * @param {string} addCustSelectedTab 
             */
            $scope.addSecondaryContact = (addCustSelectedTab) => {
                $scope.addCustSelectedTab = addCustSelectedTab;
                $scope.addCustomerObj.contacts[addCustSelectedTab].push({
                    name: '',
                    position: '',
                    email: '',
                    phone: ''
                });
            }
            /**
             * @description delete customer contacts
             * @param {number} deleteIndex 
             * @param {String} addCustSelectedTab 
             */
            $scope.deleteContact = (addCustSelectedTab, deleteIndex) => {
                $scope.addCustomerObj.contacts[addCustSelectedTab].splice(deleteIndex, 1);
            }

            /**
             * @description Update due date on selection of terms
             */
            $scope.updateDueDate = function() {
                switch ($scope.customerObj.terms) {
                    case 'Net 15' :
                        $scope.customerObj.asOf = moment().add(15, 'days');
                        break
                    case 'Net 30' :
                        $scope.customerObj.asOf = moment().add(30, 'days');
                        break
                    case 'Net 60' :
                        $scope.customerObj.asOf = moment().add(60, 'days');
                        break
                    default:
                        $scope.customerObj.asOf = moment();
                }

            }

            /**
             * @description convert to csv
             */
            $scope.ConvertToCSV = function (objArray) {
                var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
                var str = 'Customer Name, A/R Contact Name, Phone No., A/R Email, Street Address, City/Town, State/Province, Zip, Country, Preferred Payment Method, Terms, Opening Balance, As Of';
                str += '\r\n';
                for (var i = 0; i < array.length; i++) {
                    str += (array[i].name || '') + ', ' + (array[i].aRContactName || '') + ', ' +  (array[i].phone || '') + ', ' + (array[i].email || '') + ',' + ((!!array[i].address) ? array[i].address.street : '') + ',';
                    str += ((!!array[i].address) ? array[i].address.city : '') + ', ' +  ((!!array[i].address) ? array[i].address.state : '') + ', ' + ((!!array[i].address) ? array[i].address.zipCode : '') + ', ';
                    str += ((!!array[i].address) ? array[i].address.country : '') + ', ' + (array[i].prefferedPymtMtd || '') + ', ' +  ((!!array[i].terms) ? array[i].terms : '') + ', ';
                    str += (!!array[i].AR ? array[i].AR.Balance : array[i].openingBalance || 0)  + ', ' + ((!!array[i].asOf) ? moment(array[i].asOf).format('MM/DD/YYYY') : '');
                    str += '\r\n';
                }
                var uri = encodeURIComponent(str);
                return uri;
            };

             /**
             * @description export csv file
             */
            $scope.exportFile = function () {
                var dataUrl = 'data:text/csv;charset=utf-8,' + ($scope.ConvertToCSV($scope.customerList));
                var link = document.createElement('a');
                angular.element(link)
                    .attr('href', dataUrl)
                    .attr('download', 'customers-list.csv'); // Pretty much only works in chrome
                link.click();
            };
            
            /**
             * @description import selected file
             */
            $scope.fileSelected = function () {
                var payload = {},
                    _self = this,
                    importedCsv = this.$parent.fileContent.split('\n'),
                    headerLength = importedCsv[0].split(',').length;
                    if (headerLength == 13) {
                        for (var i = 1 ; i < importedCsv.length - 1; i++) {
                            var l = importedCsv[i],
                                data = l.split(',');
                            if (!!data[12].trim()) {
                                if (new Date(data[12].trim()) !== 'Invalid Date') {
                                    data[12] = new Date(data[12].trim());
                                }
                            }
                            importedCsv[i] = data.join();
                        }
                    }
                payload.userId = $scope.clientAccountId;
                payload.customers = importedCsv;
                $http.post(importCustomersAPI, payload).
                success(function () {
                    toaster.pop('success', 'Data imported successfully.');
                    $scope.getAllCustomers();
                    delete _self.$parent.fileContent;
                }).
                error(function (error) {
                    var title = 'Rejected Import, fix, and retry.',
                        message = '';
                    if (error.error.length) {
                        var linenumber = 0
                        error.error.map( function(error, index) {
                            linenumber = index + 1;
                            var errormsg = '<b>'+ linenumber + '. ' + error + '.</b> <br><br>' ;
                            message = message.concat(errormsg);
                        });
                        var height = linenumber > 10 ? 500 : 50 * linenumber;
                            height = height + 'px';
                        message = '<div class="toster-msg-trans" style="height:'+height+'">' + message + '</div>' 
                    } else {
                        message = error;
                    }
                    toaster.pop({
                        'type': 'error',
                        'title': title, 
                        'body': message,
                        'bodyOutputType': 'trustedHtml',
                        'timeout': 0,
                        'showCloseButton': true
                    });
                    $scope.getAllCustomers();
                    delete _self.$parent.fileContent;
                });
            };

            $scope.changeValue = function () {
                $scope.status = this.status;
                $scope.getAllCustomers();
            }

        }
    ]);



// WEBPACK FOOTER //
// ./packages/custom/accounting/public/controllers/customers.js